import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MultipleSortSettings } from '@progress/kendo-angular-grid';
import { ContextMenuComponent } from "@progress/kendo-angular-menu";
import { SortDescriptor } from "@progress/kendo-data-query";
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../dialogs/confirmation/confirmation-dialog.component';
import { CrossSiteUserFavoriteFormsRemoteBindingDirective } from '../../directives/cross-site-user-favorite-forms.directive';
import { KendoGridHelper } from '../../kendo-grid-helper';
import { IMenuItem } from '../../models/form-template-instances/menu-item.models';
import { CrossSiteUserFavoriteFormsData } from '../../models/site-content/cross-site-user-favorite-form.model';
import { FormInstanceService } from '../../services/form-instance.service';
import { CrossSiteUserFavoriteFormsColumnDef, CrossSiteUserFavoriteFormsStateInfo } from './cross-site-user-favorite-forms.extras';
import { KENDO_CONTEXTMENU } from '@progress/kendo-angular-menu';
import { MatIconModule } from '@angular/material/icon';
import { KENDO_GRID } from '@progress/kendo-angular-grid';

const Open_MenuItem: string = "Open";
const CopyLink_MenuItem: string = "Copy Link";

@Component({
    selector: 'app-cross-site-user-favorite-forms',
    templateUrl: './cross-site-user-favorite-forms.component.html',
    styleUrls: ['./cross-site-user-favorite-forms.component.scss'],
    encapsulation: ViewEncapsulation.None, //enable CSS overrides
    //encapsulation: ViewEncapsulation.Emulated,
    imports: [
        KENDO_CONTEXTMENU,
        KENDO_GRID,
        MatIconModule,
        CrossSiteUserFavoriteFormsRemoteBindingDirective
        ]
})
export class CrossSiteUserFavoriteFormsComponent implements OnInit {
    @ViewChild(CrossSiteUserFavoriteFormsRemoteBindingDirective) public remoteBindingDirectiveRef: CrossSiteUserFavoriteFormsRemoteBindingDirective;
    private helper = new KendoGridHelper();
    private kendoGridData: CrossSiteUserFavoriteFormsStateInfo = new CrossSiteUserFavoriteFormsStateInfo();
    @ViewChild("gridmenu") private gridContextMenu: ContextMenuComponent;

    constructor(private router: Router,
        private clipboard: Clipboard,
        private dialog: MatDialog,
        private formInstanceService: FormInstanceService) { }

    public ngOnInit(): void {
    }

    private readonly menuItems: IMenuItem[] =
        [
            { text: Open_MenuItem },
            { text: CopyLink_MenuItem },
        ];

    public columnDefs: CrossSiteUserFavoriteFormsColumnDef[] = [
        { fieldName: 'formName', title: 'Name', width: '200' },
        { fieldName: 'siteName', title: 'Site', width: '75' },
        { fieldName: 'modifiedDate', title: 'Modified Date', width: '75' },
        { fieldName: 'modifiedBy', title: 'Modified By', width: '75' },
        { fieldName: 'workflowState', title: 'Status', width: '75' }
    ];

    public openForm(dataItem: CrossSiteUserFavoriteFormsData): void {
        window.open(`/site/${dataItem.siteId}/form-instance/${dataItem.formId}`, '_blank').focus();
    }

    public toggleFave(dataItem: CrossSiteUserFavoriteFormsData): void {
        // If the user is unfaving, give them a warning that it will be removed from the Grid
        if (dataItem.isFavorite) {
            let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                width: "400px",
                data: new ConfirmationDialogModel(
                    `Unfave`,
                    `Are you sure you want to unfave the Form "${dataItem.formName}"? <br/><br/> If you proceed it will continue to display in this grid for now, but will no longer be displayed upon reload.`
                )
            });
            dialogRef.afterClosed().subscribe(yes => {
                if (yes) {
                    this.doToggleFavorite(dataItem);
                }
            });
        } else {
            this.doToggleFavorite(dataItem);
        }
    }

    private doToggleFavorite(dataItem: CrossSiteUserFavoriteFormsData) {
        dataItem.isFavorite = !dataItem.isFavorite;
        this.formInstanceService.toggleIsFavorite(dataItem.formId).then(fi => { });
    }

    public onCellClick(e: any): void {
        // Call the original code associated with a cell click.
        this.helper.setIndexOfClickedRow(e);
        // If this event is of type 'contextmenu', handle that.
        if (e.type === "contextmenu") {
            const originalEvent = e.originalEvent;
            originalEvent.preventDefault();
            this.helper.ContextMenuDataItem = e.dataItem;
            // Show the context menu.
            this.gridContextMenu.show({
                left: originalEvent.pageX,
                top: originalEvent.pageY,
            });
        }
    }

    public onContextMenuSelect(eventData: any): void {
        if ((this.helper.ContextMenuDataItem != null) && (eventData['item'] != null) && (eventData['item']['text'] != null)) {
            let menuItemText: string = eventData['item']['text'];
            switch (menuItemText) {
                case Open_MenuItem:
                    this.openForm(this.helper.ContextMenuDataItem);
                    break;
                case CopyLink_MenuItem:
                    let url: string = `${location.origin}/site/${this.helper.ContextMenuDataItem.siteId}/form-instance/${this.helper.ContextMenuDataItem.formId}`;
                    this.clipboard.copy(url);
                    break;
                default:
                    break;
            }
        }
    }

    public favIcon(dataItem: any): string {
        if (dataItem.isFavorite) {
            return "star";
        } else {
            return "star_outline";
        }
    }

    public get MenuItems(): IMenuItem[] {
        return this.menuItems;
    }

    public get SortSettings(): any {
        let settings: MultipleSortSettings = {
            //mode: "multiple",
            initialDirection: "asc",
            allowUnsort: true,
            showIndexes: true,
        };
        return settings;
    }

    // Getters / Setters
    public get ColumnDefs() {
        return this.columnDefs;
    }

    public get Helper(): KendoGridHelper {
        return this.helper;
    }
    // Getters for virtual scrolling
    public get PageSize(): number {
        return this.kendoGridData.gridState.take;
    }

    public get Skip(): number {
        return this.kendoGridData.gridState.skip;
    }
    public get Sort(): SortDescriptor[] {
        return this.kendoGridData.gridState.sort;
    }

}
